<template>
    <header class="app-header fixed-top">
        <div class="app-header-inner">
            <div class="container-fluid py-2">
                <div class="app-header-content">
                    <div class="row justify-content-between align-items-center">
                        <div class="col-auto">
                            <a id="sidepanel-toggler" class="sidepanel-toggler d-inline-block d-xl-none" href="#"
                                @click="onMenuClick()">
                                <i class="fas fa-bars"></i>
                            </a>
                        </div>

                        <div class="app-utilities col-auto">
                            <div class="app-utility-item" v-if="showStoreSelect">
                                <button type="button" class="btn app-btn-secondary" @click="showStoreSelectModal()">
                                    {{ getStore }} <i class="fa fa-caret-down"></i>
                                </button>
                            </div>
                            <div class="app-utility-item">
                                <span class="text-muted">{{ merchant }}</span>
                            </div>
                            <div class="app-utility-item">
                                <router-link to="/" @click="onBellClick"><i class="far fa-bell fs-4"></i><span
                                        class="badge bg-danger" style="margin-left: -7px;"
                                        v-if="notificationCount > 0">{{ notificationCount
                                        }}</span></router-link>
                            </div>

                            <div class="app-utility-item app-user-dropdown dropdown">
                                <a class="dropdown-toggle" id="user-dropdown-toggle" data-bs-toggle="dropdown" href="#"
                                    role="button" aria-expanded="false">
                                    <i class="far fa-user-circle fs-4"></i>
                                </a>
                                <ul class="dropdown-menu" aria-labelledby="user-dropdown-toggle">
                                    <li>
                                        <button class="dropdown-item" @click="switchMerchant">
                                            Switch Merchant
                                        </button>
                                    </li>
                                    <li>
                                        <button class="dropdown-item" href="#" @click="logOut">
                                            Log Out
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            <!--//app-user-dropdown-->
                        </div>
                        <!--//app-utilities-->
                    </div>
                    <!--//row-->
                </div>
                <!--//app-header-content-->
            </div>
            <!--//container-fluid-->
        </div>
        <!--//app-header-inner-->
        <div id="app-sidepanel" class="app-sidepanel">
            <div id="sidepanel-drop" class="sidepanel-drop"></div>
            <div class="sidepanel-inner d-flex flex-column">
                <a href="#" id="sidepanel-close" class="sidepanel-close d-xl-none" @click="onMenuClose()">&times;</a>
                <div class="app-branding">
                    <router-link to="/" class="app-logo">
                        <img class="logo-icon me-2" :src="require('@/assets/logo.png')" alt="logo" /><span
                            class="logo-text">OMS</span>
                    </router-link>
                </div>
                <!--//app-branding-->

                <nav id="app-nav-main" class="app-nav app-nav-main flex-grow-1">
                    <ul class="app-menu list-unstyled accordion" id="menu-accordion">
                        <li class="nav-item">
                            <!--//Bootstrap Icons: https://icons.getbootstrap.com/ -->

                            <router-link to="/" class="nav-link">
                                <span class="nav-icon">
                                    <i class="fas fa-home"></i>
                                </span>
                                <span class="nav-link-text">Orders</span>
                            </router-link>
                            <!--//nav-link-->
                        </li>
                        <li class="nav-item has-submenu">
                            <a class="nav-link submenu-toggle" href="/discounts" data-bs-toggle="collapse"
                                data-bs-target="#submenu-1" aria-expanded="false" aria-controls="submenu-1">
                                <span class="nav-icon">
                                    <!--//Bootstrap Icons: https://icons.getbootstrap.com/ -->
                                    <i class="bi bi-ticket-perforated-fill"></i>
                                </span>
                                <span class="nav-link-text">Discounts</span>
                                <span class="submenu-arrow">
                                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-chevron-down"
                                        fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                                    </svg>
                                </span>
                                <!--//submenu-arrow-->
                            </a>
                            <!--//nav-link-->
                            <div id="submenu-1" class="collapse submenu submenu-1" data-bs-parent="#menu-accordion">
                                <ul class="submenu-list list-unstyled">
                                    <li class="submenu-item">
                                        <router-link to="/discounts/new" class="submenu-link">Create
                                            New</router-link>
                                    </li>
                                    <li class="submenu-item">
                                        <router-link to="/discounts" class="submenu-link">Manage</router-link>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li class="nav-item">
                            <!--//Bootstrap Icons: https://icons.getbootstrap.com/ -->

                            <router-link to="/rules" class="nav-link">
                                <span class="nav-icon">
                                    <i class="fas fa-legal"></i>
                                </span>
                                <span class="nav-link-text">Rules</span>
                            </router-link>
                            <!--//nav-link-->
                        </li>
                        <li class="nav-item">
                            <!--//Bootstrap Icons: https://icons.getbootstrap.com/ -->

                            <router-link to="/payment-gateways" class="nav-link">
                                <span class="nav-icon">
                                    <i class="fas fa-coins"></i>
                                </span>
                                <span class="nav-link-text">Payment Gateways</span>
                            </router-link>
                            <!--//nav-link-->
                        </li>
                    </ul>
                    <!--//app-menu-->
                </nav>
                <!--//app-nav-->
                <div class="app-sidepanel-footer">
                    <nav class="app-nav app-nav-footer">
                        <ul class="app-menu footer-menu list-unstyled">
                            <!--//nav-item-->
                            <li class="nav-item">
                                <!--//Bootstrap Icons: https://icons.getbootstrap.com/ -->
                                <router-link to="/settings" class="nav-link">
                                    <span class="nav-icon">
                                        <i class="fa fa-cog"></i>
                                    </span>
                                    <span class="nav-link-text">Settings</span>
                                </router-link><!--//nav-link-->
                            </li>
                            <!--//nav-item-->
                            <li class="nav-item">
                                <!--//Bootstrap Icons: https://icons.getbootstrap.com/ -->
                                <a class="nav-link" :href="helpUrl" target="_blank">
                                    <span class="nav-icon">
                                        <i class="far fa-question-circle"></i>
                                    </span>
                                    <span class="nav-link-text">Help</span>
                                </a><!--//nav-link-->
                            </li>
                            <!--//nav-item-->
                        </ul>
                        <!--//footer-menu-->
                    </nav>
                </div>
                <!--//app-sidepanel-footer-->
            </div>
            <!--//sidepanel-inner-->
        </div>
        <!--//app-sidepanel-->
    </header>
    <StoreSelect />
</template>

<script>
import StoreSelect from "@/components/StoreSelect.vue";
import * as navbar from "@/services/navbar.service";
import { logout } from '@/services/oidc.service';
import orderHubService from "@/services/order-hub.service";
import { emitter } from "@/services/emitter.service";
import { getModalInstance } from "@/services/bs-modal.service";

export default {
    components: { StoreSelect },
    data: () => ({
        merchant: localStorage.getItem("merchant"),
        helpUrl: process.env.VUE_APP_HELP_URL,
        store: null,
        showStoreSelect: true,
    }),
    computed: {
        // Access the notification count directly from the Vuex store
        notificationCount() {
            return this.$store.state.notifications.count;
        },
        getStore() {
            return this.store?.name || localStorage.getItem("store");
        }
    },
    created() {
        emitter.on("storeSelect", (e) => {
            this.store = e;
        });

        emitter.on("hideStoreSelect", () => {
            this.showStoreSelect = false;
        });
    },
    mounted() {
        orderHubService.startConnection().then(() => {
            // Listen to the 'ReceiveMessage' event from the hub
            orderHubService.onReceiveMessage((message) => {
                // Handle received message
                console.log('Received message:', message);
                this.$store.commit('increment');
                navbar.init(this.$route);

                // Play sound after receiving message
                const audio = new Audio('/dingdong.mp3'); // Use your sound file path here
                audio.play();
            });

            console.log('Started SignalR connection')
        }).catch((error) => {
            // Handle connection start error
            console.error('Failed to start SignalR connection', error);
        });
    },

    methods: {
        onMenuClick() {
            document
                .getElementById("app-sidepanel")
                .classList.add("sidepanel-visible");
        },

        onMenuClose() {
            document
                .getElementById("app-sidepanel")
                .classList.remove("sidepanel-visible");
        },

        logOut() {
            localStorage.clear();
            logout();
        },

        switchMerchant() {
            localStorage.removeItem("merchant");
            window.location.href = "/init";
        },

        onBellClick() {
            emitter.emit("refreshOrders", null);
            this.$store.commit('reset');
            document.title = 'OMS';
        },

        showStoreSelectModal() {
            getModalInstance("storeSelect").show();
        }
    },
};
</script>

<style scope>
.app-nav .nav-icon {
    position: absolute;
    left: 1rem;
    top: initial;
}

.cursor-pointer {
    cursor: pointer;
}
</style>